import React from 'react'

const Seperator = () => {
  return (
    <div className="separator"></div>
  )
}

export default Seperator